import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import { isArrayWithItems } from '../../../utils';
import { ILegendItem } from '../../../utils/legend';

import * as styles from './index.css';

export interface ILegendProps {
  legendData: ILegendItem[];

  openModal(): void;
}

export class Legend extends React.PureComponent<ILegendProps, {}> {
  public render() {
    const { legendData } = this.props;

    if (!isArrayWithItems(legendData)) {
      return null;
    }

    return (
      <ul className={styles['container']}>
        {legendData.slice(0, 3).map(item => (
          <li
            key={item.color}
            className={styles['item']}
            style={{
              borderColor: item.color,
            }}
          >
            {item.title}
          </li>
        ))}
        {legendData.length > 3 && (
          <li {...mergeStyles(styles['item'], styles['more'])} onClick={this.props.openModal} />
        )}
      </ul>
    );
  }
}
